import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify'
import './plugins/axios' // Import Axios konfigurácie
import './assets/main.scss'

// Vytvorenie Vue aplikácie
const app = createApp(App)

// Registrácia Pinia store
app.use(createPinia())

// Registrácia Vue Router
app.use(router)

// Registrácia Vuetify
app.use(vuetify)

// Mountovanie aplikácie
app.mount('#app')
